import MojitoPresentation from 'mojito/presentation';
import PriceBoostItem from 'modules/price-boost-item/index.js';

const { FlexPane } = MojitoPresentation.Components;
const { MarketHelper } = MojitoPresentation.Utils;

const PriceBoostMarketContent = props => {
    const { aggregatedMarket, eventItem, mojitoTools } = props;
    const { config, appContext } = mojitoTools;
    const markets = aggregatedMarket.markets.filter(Boolean);
    const { language } = appContext.systemSettings();
    MarketHelper.sortMarkets(markets, language);
    return (
        <FlexPane class="ta-PriceBoostMarketContent" config={config.container}>
            {markets.map(market => (
                <BoostedMarketLine
                    key={market.id}
                    config={config}
                    market={market}
                    event={eventItem}
                />
            ))}
        </FlexPane>
    );
};

const BoostedMarketLine = ({ config, market, event }) => {
    const boostedSelections = market.selections.filter(selection => selection.basePrice);
    return (
        <>
            {boostedSelections.map(selection => (
                <PriceBoostItem
                    key={selection.id}
                    config={config.priceBoostItem}
                    selection={selection}
                    market={market}
                    event={event}
                />
            ))}
        </>
    );
};

export default PriceBoostMarketContent;
